import { Markdown } from "@/components/Markdown";
import styled from "@emotion/styled";
import { Text, Variables } from "@repo/skapa";
import { t } from "@repo/translation";

const Container = styled.div`
  & > :first-child {
    margin-bottom: ${Variables.space50};
  }
`;

interface SummaryProps {
  summary: string;
}

export const Summary = ({ summary }: SummaryProps) => {
  return (
    <Container>
      <Text textStyle="Label.M">{t("label.ai_summary_title")}</Text>
      <Markdown>{summary}</Markdown>
    </Container>
  );
};
